/** Discrete badge colors for terminal / outcome statuses. */
export function bigQuerySyncJobStatusBadgeClass(status: string | null | undefined): string {
  const u = (status ?? '').trim().toUpperCase();
  if (u === 'APPLIED' || u === 'APPROVED') {
    return 'border-emerald-600/30 bg-emerald-500/[0.07] text-emerald-900 dark:border-emerald-500/35 dark:bg-emerald-500/12 dark:text-emerald-100';
  }
  if (u === 'REJECTED') {
    return 'border-rose-600/30 bg-rose-500/[0.07] text-rose-900 dark:border-rose-500/35 dark:bg-rose-500/12 dark:text-rose-100';
  }
  return '';
}
